export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 bg-background-50 overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.04] bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Delicate%20fashion%20product%20flat%20lay%20with%20linen%20clothing%20straw%20accessories%20and%20leather%20goods%20on%20whitewashed%20wooden%20surface%20soft%20Mediterranean%20afternoon%20light%20gentle%20shadows%20warm%20neutral%20palette%20relaxed%20Italian%20summer%20editorial%20style%20airy%20clean%20composition&width=1800&height=600&seq=cta-bg-v2-03&orientation=landscape')`,
        }}
      ></div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Pronto a scoprire{' '}
            <span className="text-primary-500 italic">Itaobuy Spreadsheet?</span>
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mb-10">
            Accedi ora e inizia a esplorare tutte le categorie disponibili. Trova i prodotti migliori in modo semplice e organizzato.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all shadow-sm whitespace-nowrap cursor-pointer"
            >
              itaobuy sheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-300 text-foreground-800 text-base font-semibold hover:border-foreground-400 hover:bg-foreground-50/50 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
          </div>

          <div className="mt-16 relative">
            <div className="flex items-center justify-center gap-6 md:gap-12 flex-wrap">
              {['Shoes', 'Hoodies', 'T-Shirts', 'Bags', 'Jersey'].map((item) => (
                <span
                  key={item}
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-background-100 text-sm font-medium text-foreground-600"
                >
                  <span className="w-2 h-2 rounded-full bg-primary-400"></span>
                  {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}